import { render, staticRenderFns } from "./RatingPlanForm.vue?vue&type=template&id=592df585&"
import script from "./RatingPlanForm.vue?vue&type=script&lang=js&"
export * from "./RatingPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports